import { render, staticRenderFns } from "./Get724.vue?vue&type=template&id=f1e29254&scoped=true"
import script from "./Get724.vue?vue&type=script&lang=js"
export * from "./Get724.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e29254",
  null
  
)

export default component.exports